export const FORGET_USER = 'login_user';
export const FORGET_USER_SUCCESSFUL = 'forget_user_successfull';
export const FORGET_PASSWORD_API_FAILED = 'api_failed';

export const UPDATE_PW = 'UPDATE_PW';
export const UPDATE_PW_SUCCESSFUL = 'UPDATE_PW_SUCCESSFUL';
export const UPDATE_PW_FAILED = 'UPDATE_PW_FAILED';

export const RESET_FORGOT_PW_STATE = 'RESET_FORGOT_PW_STATE';
